import { useState } from "react";
import Edit from "./edit";
import { History } from "./history";
import { useQueryClient } from "@tanstack/react-query";
import { PageTabs } from "@/components/ui/page-tabs";

const UserDetails = () => {
  const [activeTab, setActiveTab] = useState<"details" | "history">("details");

  const queryClient = useQueryClient();

  return (
    <div className="flex flex-col gap-3 tablet:gap-4 laptop:gap-6 desktop:gap-8">
      <PageTabs
        tabs={[
          { label: "Detalles", key: "details" },
          { label: "Historial", key: "history" },
        ]}
        activeKey={activeTab}
        onTabChange={(key) => {
          setActiveTab(key as "details" | "history");
          if (key === "history") {
            queryClient.invalidateQueries({ queryKey: ["admin-log-list"] });
          }
        }}
      ></PageTabs>
      {activeTab === "details" && <Edit />}
      {activeTab === "history" && <History />}
    </div>
  );
};

export default UserDetails;
